import { observer } from 'mobx-react'

import { TermsAndConditions } from '@/components/TermsAndConditions/TermsAndConditions'

export const TermsAndConditionsElavonPage = observer(() => {
  return <TermsAndConditions showRequired={false} />
})
